export const sizeChoices = {
    h1: {
        label: 'Heading 1',
        value: 'h1'
    },
    h2: {
        label: 'Heading 2',
        value: 'h2'
    },
    h3: {
        label: 'Heading 3',
        value: 'h3'
    },
    h4: {
        label: 'Heading 4',
        value: 'h4'
    },
    h5: {
        label: 'Heading 5',
        value: 'h5'
    },
    h6: {
        label: 'Heading 6',
        value: 'h6'
    },
    body1: {
        label: 'Body 1',
        value: 'body1'
    },
    body2: {
        label: 'Body 2',
        value: 'body2'
    },
    subtitle1: {
        label: 'Subtitle 1',
        value: 'subtitle1'
    },
    subtitle2: {
        label: 'Subtitle 2',
        value: 'subtitle2'
    }
};
